import { ProductProps } from '../../type'
import { ProductCategory, ProductTag } from '../../enum'
import imageBanner from './img/banner.png'
import imageTable1 from './img/table-1.jpg'
import imageTable2 from './img/table-2.jpg'
import imageTable3 from './img/table-3.jpg'
import imageTable4 from './img/table-4.jpg'
import imageTable5 from './img/table-5.jpg'
import imageTable6 from './img/table-6.jpg'
import imageTable7 from './img/table-7.jpg'
import imageCertificate1 from './img/certificate-1.jpg'
import imageCertificate2 from './img/certificate-2.jpg'

export const ceTitanV4: ProductProps = {
  tag: ProductTag.PV,
  category: ProductCategory.DistributedPVStorageSystems,
  pathName: 'ce-titan-v4',
  banner: imageBanner,
  title: 'CE-Titan V4',
  specImages: [imageTable1, imageTable2, imageTable3, imageTable4, imageTable5, imageTable6, imageTable7],
  certificateImages: [imageCertificate1, imageCertificate2],
}
